module.exports = __webpack_public_path__ + "static/media/fork-and-knife-on-white-ceramic-plate.8c85feb6.jpg";